<template>
  <v-container>
    <sc-text :field="this.fields.SectionTitle" tag="h3" class="section-title" />
    <v-row>
      <v-col cols="12" class="px-0">
        <sc-placeholder name="jsscards" :rendering="rendering" class="cards-row row" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'PromoCards',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  computed: {},
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder,
  },
};
</script>
<style lang="scss" scoped>
.section-title {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 20px;
    line-height: 140%;
    padding-left: 0px;
  }
  font-size: 22px;
  line-height: 158%;
  font-weight: map-get($font-weights, 'normal');
  color: map-deep-get($colors, 'blue-text', 'base');
  word-break: normal !important;
}
.cards-row {
  &::v-deep {
    .promo-content-card {
      min-width: 300px;
      margin-left: 12px;
      margin-right: 12px;
      margin-bottom: 16px !important;
      @media #{map-get($display-breakpoints, 'lg-and-up')} {
        width: calc(100% / 3 - 24px) !important;
      }
      @media #{map-get($display-breakpoints, 'xs-only')} {
        width: calc(100% - 24px);
      }
      @media #{map-get($display-breakpoints, 'sm-and-up')} {
        width: calc(100% / 2 - 24px);
        height: auto !important;
      }
    }
  }
}
</style>
